import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, vModelText as _vModelText, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60ee0f78"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-sm-6 text-center" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "col-sm-6 text-center" }
const _hoisted_6 = { class: "card" }
const _hoisted_7 = { class: "col-sm-6 text-center" }
const _hoisted_8 = { class: "card" }
const _hoisted_9 = { class: "col-sm-6 text-center" }
const _hoisted_10 = { class: "card" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_12 = { class: "flexRow" }
const _hoisted_13 = { class: "col-sm-12" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = { value: "" }
const _hoisted_16 = ["value"]
const _hoisted_17 = {
  type: "submit",
  class: "btn btn-primary"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { colspan: "99" }
const _hoisted_21 = { class: "text-danger" }
const _hoisted_22 = { class: "text-success" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_24 = { style: {"display":"flex","flex-wrap":"wrap"} }
const _hoisted_25 = { class: "paginationContainer" }
const _hoisted_26 = { class: "paginationTotal" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Totale: ")
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 10 }, "10", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 25 }, "25", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 50 }, "50", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 100 }, "100", -1))
const _hoisted_32 = [
  _hoisted_28,
  _hoisted_29,
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_form_input = _resolveComponent("form-input")!
  const _component_op_table = _resolveComponent("op-table")!
  const _component_mini_spinner = _resolveComponent("mini-spinner")!
  const _component_provvigioni_table = _resolveComponent("provvigioni-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h3", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "Maturato",
                text: "Maturato"
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.portafoglio.totaleMaturato) + " €", 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h3", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "Pagato",
                text: "Pagato"
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.portafoglio.totalePagato) + " €", 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("h3", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "In attesa",
                text: "In attesa"
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.portafoglio.totaleInAttesa) + " €", 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("h3", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "Saldo",
                text: "Saldo"
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.portafoglio.saldoAttuale) + " €", 1)
            ])
          ])
        ])
      ])
    ]),
    _hoisted_11,
    _createElementVNode("h4", null, [
      _createVNode(_component_localized_text, {
        localizedKey: "Nuova ricevuta",
        text: "Nuova ricevuta"
      })
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("form", {
          onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.insertRicevuta && _ctx.insertRicevuta(...args)), ["prevent"]))
        }, [
          _createVNode(_component_form_input, {
            type: "text",
            label: "Numero",
            modelValue: _ctx.ricevuta.numeroRicevuta,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ricevuta.numeroRicevuta) = $event)),
            placeholder: "Numero"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_form_input, {
            type: "number",
            label: "Importo",
            modelValue: _ctx.ricevuta.importo,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.ricevuta.importo) = $event)),
            placeholder: "Importo"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_form_input, {
            label: "Data Acquisto",
            modelValue: _ctx.ricevuta.data,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.ricevuta.data) = $event)),
            type: "date"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_form_input, {
            label: "Note",
            modelValue: _ctx.ricevuta.note,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.ricevuta.note) = $event)),
            type: "text"
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("label", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "Nazione",
                text: "Nazione"
              })
            ]),
            _withDirectives(_createElementVNode("select", {
              class: "form-control",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.ricevuta.nazione) = $event))
            }, [
              _createElementVNode("option", _hoisted_15, _toDisplayString(_ctx.$localizationService.GetLocalizedValue("Nazione", "Nazione")), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nazioni, (item, i) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: i,
                  value: item
                }, _toDisplayString(item), 9, _hoisted_16))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.ricevuta.nazione]
            ])
          ]),
          _createElementVNode("button", _hoisted_17, [
            _createVNode(_component_localized_text, {
              localizedKey: "Salva ricevuta",
              text: "Salva ricevuta"
            })
          ])
        ], 32)
      ])
    ]),
    _hoisted_18,
    _createElementVNode("h4", null, [
      _createVNode(_component_localized_text, {
        localizedKey: "Ricevute",
        text: "Ricevute"
      })
    ]),
    _createVNode(_component_op_table, {
      class: "table table-striped",
      items: _ctx.ricevute
    }, {
      default: _withCtx((opData) => [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "Data",
                text: "Data"
              })
            ]),
            _createElementVNode("th", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "Dare",
                text: "Dare"
              })
            ]),
            _createElementVNode("th", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "Avere",
                text: "Avere"
              })
            ]),
            _createElementVNode("th", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "Numero",
                text: "Numero"
              })
            ]),
            _createElementVNode("th", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "Note",
                text: "Note"
              })
            ])
          ])
        ]),
        _createElementVNode("tbody", null, [
          (opData.items.length == 0)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [
                _createElementVNode("td", _hoisted_20, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Nessun elemento trovato",
                    text: "Nessun elemento trovato"
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(opData.items, (item, i) => {
            return (_openBlock(), _createElementBlock("tr", { key: i }, [
              _createElementVNode("td", null, _toDisplayString(_ctx.$filters.date(item.dataPagamento)), 1),
              _createElementVNode("td", _hoisted_21, _toDisplayString(item.importoEuro > 0 ? -item.importoEuro + ' €' : ''), 1),
              _createElementVNode("td", _hoisted_22, _toDisplayString(!(item.importoEuro > 0) ? -item.importoEuro + ' €' : ''), 1),
              _createElementVNode("td", null, _toDisplayString(item.numeroRicevuta), 1),
              _createElementVNode("td", null, _toDisplayString(item.note), 1)
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["items"]),
    _hoisted_23,
    _createElementVNode("h4", null, [
      _createVNode(_component_localized_text, {
        localizedKey: "Provvigioni",
        text: "Provvigioni"
      })
    ]),
    (_ctx.loadingProvvigioni)
      ? (_openBlock(), _createBlock(_component_mini_spinner, { key: 0 }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_24, [
            _withDirectives(_createElementVNode("input", {
              type: "date",
              placeholder: "Created On",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.vm.createdOn) = $event))
            }, null, 512), [
              [_vModelText, _ctx.vm.createdOn]
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: "Cliente",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.vm.cliente) = $event))
            }, null, 512), [
              [_vModelText, _ctx.vm.cliente]
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: "Prodotto",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.vm.prodotto) = $event))
            }, null, 512), [
              [_vModelText, _ctx.vm.prodotto]
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "number",
              placeholder: "Euro",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.vm.importoEuro) = $event))
            }, null, 512), [
              [
                _vModelText,
                _ctx.vm.importoEuro,
                void 0,
                { number: true }
              ]
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: "Figlio",
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.vm.figlio) = $event))
            }, null, 512), [
              [_vModelText, _ctx.vm.figlio]
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: "Qualifica Figlio",
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.vm.qualificaFiglio) = $event))
            }, null, 512), [
              [_vModelText, _ctx.vm.qualificaFiglio]
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: "Utente",
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.vm.utente) = $event))
            }, null, 512), [
              [_vModelText, _ctx.vm.utente]
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: "Qualifica Utente",
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.vm.qualificaUtente) = $event))
            }, null, 512), [
              [_vModelText, _ctx.vm.qualificaUtente]
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "number",
              placeholder: "Points",
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.vm.points) = $event))
            }, null, 512), [
              [
                _vModelText,
                _ctx.vm.points,
                void 0,
                { number: true }
              ]
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "number",
              placeholder: "Guadagno €",
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.vm.guadagnoEuro) = $event))
            }, null, 512), [
              [
                _vModelText,
                _ctx.vm.guadagnoEuro,
                void 0,
                { number: true }
              ]
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.init && _ctx.init(...args)))
            }, "Applica")
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("span", _hoisted_26, [
              _hoisted_27,
              _createElementVNode("b", null, _toDisplayString(_ctx.pagedResult.count), 1)
            ]),
            _withDirectives(_createElementVNode("select", {
              class: "itemsPerPage",
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.vm.perPage) = $event)),
              onChange: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.init && _ctx.init(...args)))
            }, _hoisted_32, 544), [
              [_vModelSelect, _ctx.vm.perPage]
            ]),
            _createElementVNode("div", {
              class: "paginationNumber",
              onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.subtractPage && _ctx.subtractPage(...args)))
            }, " < "),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["paginationNumber", {selected: _ctx.vm.pageNumber == i}]),
                key: i,
                onClick: ($event: any) => (_ctx.setSelectedPage(i))
              }, _toDisplayString(i), 11, _hoisted_33))
            }), 128)),
            _createElementVNode("div", {
              class: "paginationNumber",
              onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.addPage && _ctx.addPage(...args)))
            }, " > ")
          ]),
          _createVNode(_component_provvigioni_table, {
            rowData: _ctx.pagedResult.data
          }, null, 8, ["rowData"])
        ], 64))
  ]))
}